import { render, staticRenderFns } from "./PostNewArea.vue?vue&type=template&id=d6a5c61a&scoped=true&"
import script from "./PostNewArea.vue?vue&type=script&lang=js&"
export * from "./PostNewArea.vue?vue&type=script&lang=js&"
import style0 from "./PostNewArea.vue?vue&type=style&index=0&id=d6a5c61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a5c61a",
  null
  
)

export default component.exports